'use es6';

import { PROJECT, DESIGN_ROOT } from 'DesignData/enums/FolderSubcategories';
export const isProjectsFolder = folder => {
  return folder && folder.subcategory === PROJECT;
};
export function getAssetParentProjectFolderId(files, folders, assetId) {
  if (!assetId) return null;
  const asset = files[assetId] || folders[assetId];
  if (!asset) return null;
  if (isProjectsFolder(asset)) return assetId;
  if (asset.subcategory === DESIGN_ROOT) return null;
  const parentFolderId = asset.parentFolderId || asset.folderId;
  if (!parentFolderId) return null;
  return getAssetParentProjectFolderId(files, folders, parentFolderId);
}
export const projectConfigTemplate = (templateOptions = {}) => {
  return JSON.stringify({
    label: templateOptions.label || 'New Project',
    description: templateOptions.description || ''
  }, null, 2);
};